import Sortable, { MultiDrag } from "sortablejs";

// 한 번만 마운트
Sortable.mount(new MultiDrag());
